<style scoped>
  .tag { font-size: 1.0rem; background: #4a4a4a; color: white }
</style>

<template>
  <div class="columns animated fadeIn">
    <div class="column">
      <span>
        <h2 class="title is-marginless"> {{ usuario.nome }} </h2>
        <h4 class="subtitle is-marginless">
          Resumo do mês: <span class="tag m-r-xs">{{ dia | moment("MMMM  YYYY") }}</span>
        </h4>
      </span>
    </div>

    <div class="column" v-if="temSlot">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    created () {
      this.usuario = this.$air.usuarioLogado()
    },
    data () {
      return {
        usuario: {},
        dia: new Date()
      }
    },
    computed: {
      temSlot () {
        return !!this.$slots.default
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PortalPerfil.vue